import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'px-button',
    templateUrl: './px-button.component.html',
    styleUrls: ['./px-button.component.scss'],
})
export class PxButtonComponent {
    /**
     * The id global attribute defines an identifier (ID) which must be unique in the whole document.
     * Its purpose is to identify the element when linking. <b>The postfix '_btn' will be appended to the id.</b>
     */
    @Input()
    public id: string;

    /**
     * The aria-label attribute is used to define a string that labels the current element.
     * Use it in cases where a text label is not visible on the screen.
     */
    @Input()
    public ariaLabel: string;

    /**
     * The class global attribute is a space-separated list of the case-sensitive classes of the element.
     */
    @Input()
    public styleClass: string;

    /**
     * The buttonType attribute is used to set a predefined button design<br>
     * Possible values:<br>
     * <ul>
     *    <li>primary</li>
     *    <li>secondary</li>
     *    <li>tertiary</li>
     *    <li>ghost</li>
     *    <li>primary-ondark</li>
     *    <li>secondary-ondark</li>
     * </ul>
     * The default value is <b>primary</b>
     */
    @Input()
    public buttonStyleType: 'primary' | 'secondary' | 'tertiary' | 'ghost' | 'primary-ondark' | 'secondary-ondark' =
        'primary';

    /**
     * The disableButtonAfterClicked attribute is used disable the button after clicked. This will prevent multiple clicks.
     */
    @Input()
    public disableButtonAfterClicked = false;

    /**
     * The buttonClicked attribute is an EventEmitter which will emit an event in case the button was clicked.
     */
    @Output()
    public buttonClicked = new EventEmitter<Event>();

    public isDisabled = false;

    public onClick(event: Event) {
        this.isDisabled = this.disableButtonAfterClicked;
        event.preventDefault();
        event.stopPropagation();
        this.buttonClicked.next(event);
    }

    public set disable(value: boolean) {
        this.isDisabled = value;
    }
}
